import script from "./auth-redirect.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-redirect.vue?vue&type=script&lang=ts&setup=true"

import "./auth-redirect.vue?vue&type=style&index=0&id=10d63fad&lang=css"

const __exports__ = script;

export default __exports__